module.exports = __webpack_public_path__ + "img/ic_truck_hanging.80a322d0.svg";